export const AUTH_MODAL_VIEW = {
  LOGIN: 'login',
} as const;

export type AuthModalView = (typeof AUTH_MODAL_VIEW)[keyof typeof AUTH_MODAL_VIEW];

export type ProfileSection = 'profile' | 'trading';

export interface ProfileSidebarItem {
  label: string;
  value: ProfileSection;
}

export const PROFILE_SIDEBAR_ITEMS: ProfileSidebarItem[] = [
  { label: 'profile.title', value: 'profile' },
  // { label: 'profile.trading', value: 'trading' },
];
